import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { BASE_URL } from '../config/api';

const EditBazarWork = () => {
  const { id } = useParams(); // Get the ID from the URL
  const navigate = useNavigate();

  const [bazarWork, setBazarWork] = useState({
    title: '',
    description: '',
    date: '',
    images: [],
  });
  const [newImages, setNewImages] = useState([]);
  const [loading, setLoading] = useState(true);

  // Fetch the specific Bazar Work details by ID when component mounts
  useEffect(() => {
    fetch(`${BASE_URL}bazarworks/${id}`)
      .then(response => response.json())
      .then(data => {
        if (data.status === 1) {
          const fetchedBazarWork = data.data;

          // Ensure images is an array
          const images = Array.isArray(fetchedBazarWork.images)
            ? fetchedBazarWork.images
            : JSON.parse(fetchedBazarWork.images || '[]'); // Parse stringified images if needed

          // Format the date to YYYY-MM-DD format if it's not already in that format
          const formattedDate = new Date(fetchedBazarWork.date).toISOString().split('T')[0]; // Format date to 'YYYY-MM-DD'

          setBazarWork({
            ...fetchedBazarWork,
            images, // Make sure images is an array
            date: formattedDate, // Set the formatted date
          });
          setLoading(false); // Stop loading when data is fetched
        } else {
          console.error('Failed to fetch bazar work:', data.message);
        }
      })
      .catch(error => {
        console.error('Error fetching bazar work:', error);
        setLoading(false); // Stop loading if an error occurs
      });
  }, [id]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setBazarWork((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleImageChange = (e) => {
    setNewImages(e.target.files); // Add new images
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append('title', bazarWork.title);
    formData.append('description', bazarWork.description);
    formData.append('date', bazarWork.date);
    // Append new images if any
    Array.from(newImages).forEach((file) => formData.append('images[]', file));

    // Send PUT request to update the bazar work
    fetch(`${BASE_URL}bazarworks/${id}`, {
      method: 'PUT',
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === 1) {
          alert('Bazar work updated successfully!');
          navigate('/BazarList'); // Redirect to Bazar List after successful update
        } else {
          console.error('Failed to update bazar work:', data.message);
        }
      })
      .catch((error) => {
        console.error('Error updating bazar work:', error);
      });
  };

  if (loading) {
    return <div>Loading...</div>; // Show loading message until the data is fetched
  }

  return (
    <div id="main">
      <header className="mb-3">
        <a href="#" className="burger-btn d-block d-xl-none">
          <i className="bi bi-justify fs-3"></i>
        </a>
      </header>

      <div className="page-heading">
        <div className="page-title">
          <div className="row">
            <div className="col-12 col-md-6 order-md-1 order-last">
              <h3>Edit Bazar Work</h3>
            </div>
          </div>
        </div>
      </div>

      <section className="section">
        <div className="row">
          <div className="col-12 col-md-12">
            <div className="card">
              <div className="card-header">
                <h4>Edit Bazar Work</h4>
              </div>
              <div className="card-body">
                <form onSubmit={handleSubmit}>
                  <div className="mb-3">
                    <label htmlFor="title" className="form-label">Title</label>
                    <input
                      type="text"
                      id="title"
                      name="title"
                      className="form-control"
                      value={bazarWork.title}
                      onChange={handleInputChange}
                      required
                    />
                  </div>

                  <div className="mb-3">
                    <label htmlFor="description" className="form-label">Description</label>
                    <textarea
                      id="description"
                      name="description"
                      className="form-control"
                      value={bazarWork.description}
                      onChange={handleInputChange}
                      required
                    />
                  </div>

                  <div className="mb-3">
                    <label htmlFor="date" className="form-label">Date</label>
                    <input
                      type="date"
                      id="date"
                      name="date"
                      className="form-control"
                      value={bazarWork.date} // Display the correctly formatted date
                      onChange={handleInputChange}
                      required
                    />
                  </div>

                  <div className="mb-3">
                    <label htmlFor="images" className="form-label">Images</label>
                    <input
                      type="file"
                      id="images"
                      name="images"
                      className="form-control"
                      accept="image/*"
                      multiple
                      onChange={handleImageChange}
                    />
                    <div className="mt-2">
                      {/* Display existing images */}
                      {bazarWork.images.length > 0 &&
                        bazarWork.images.map((image, index) => (
                          <img
                            key={index}
                            src={`${BASE_URL}${image}`}
                            alt={`Bazar Work Image ${index + 1}`}
                            style={{ width: '100px', height: '100px', marginRight: '10px' }}
                          />
                        ))}
                    </div>
                  </div>

                  <button type="submit" className="btn btn-primary">Save Changes</button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default EditBazarWork;
